import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalHelper {

  constructor(
    private ngbModal: NgbModal
  ) { }

  open<T>(content: T, options?: NgbModalOptions): NgbModalRef {
    return this.ngbModal.open(content, options);
  }

  getStrictModalOptions(): NgbModalOptions {
    return {
      backdrop: 'static',
      keyboard: false
    };
  }
}
